export default __webpack_public_path__ + "static/media/avatar.cb9f6b64.png";